import React from 'react';
import style from './style.module.scss';

function Single({
  value: {
    description,
    info: { cover },
    user: { name },
  },
}) {
  return (
    <>
      <div className={style.wrapper}>
        <img
          className={style.cover}
          src={cover}
        />
        <div className={style.content}>
          <b>{name}</b> {description}
        </div>
      </div>
    </>
  );
}

export default Single;
